<template>
  <div v-if="uiTranslationsLoaded">
    <slot />
  </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import {
  locales
} from "../config/i18n";
import {
  switchDocumentLocale
} from "../services/i18n/util";
import {
  setUiLocale,
  t,
  currentLocale
} from "../services/i18n/index.js";
export default {
  data() {
    return {
      uiTranslationsLoaded: false
    };
  },
  methods: {
    set(locale) {
      var filteredLocale = locale;

      if (String(locale).length != 2) {
        filteredLocale = localStorage.getItem("locale");
      } else {
        localStorage.setItem("locale", locale);
      }
      this.uiTranslationsLoaded = false;
      setUiLocale(filteredLocale)
        .then(() => {
          Vue.prototype.$t = t;
          this.uiTranslationsLoaded = true;
          const dir = _.find(locales, l => l.code === filteredLocale).dir;
          switchDocumentLocale(
            filteredLocale,
            dir, {
              withRTL: [
                "/static/styles/vendor/GhalamborM/bootstrap4-rtl.css",
                "/static/styles/rtl.css"
              ]
            }
          );
        })
      /* eslint-disable no-console */
        .catch(err => console.error(err));
    }
  },
  mounted() {
    this.set(this.$route.params.locale || "en");
  },
  watch: {
    /* eslint-disable object-shorthand */
    "$route"(to) {
      if (to.params.locale !== currentLocale()) {
        this.set(to.params.locale);
      }
    }
  }
};
</script>
